import React, { useEffect, useState, useRef } from "react";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet } from "../../CommonUtils/CommonAxios";
import { useReactToPrint } from "react-to-print";
import { viewImage } from "../../CommonUtils/viewImage";
import { FaEye, FaFilePdf } from "react-icons/fa";

/* ─── CSS ───────────────────────────────────────────────────────────── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

.sp-root * { box-sizing: border-box; margin: 0; padding: 0; }
.sp-root {
  font-family: 'Plus Jakarta Sans', sans-serif;
  background: #eef4fb;
  min-height: 100vh;
  padding: 28px 32px;
}

/* PAGE HEADER */
.sp-page-hdr {
  display: flex; align-items: flex-start;
  justify-content: space-between; flex-wrap: wrap;
  gap: 14px; margin-bottom: 24px;
}
.sp-page-eyebrow {
  font-size: 11px; font-weight: 700; color: #0d9488;
  text-transform: uppercase; letter-spacing: .08em; margin-bottom: 4px;
}
.sp-page-title {
  font-size: 22px; font-weight: 800; color: #0f172a;
  display: flex; align-items: center; gap: 10px;
}
.sp-page-sub { font-size: 12px; color: #64748b; margin-top: 4px; }
// .sp-reg-badge {
//   display: inline-flex; align-items: center; gap: 6px;
//   padding: 4px 13px; border-radius: 20px;
//   background: #dbeafe; color: #1e40af;
//   border: 1px solid #93c5fd; font-size: 12px; font-weight: 700;
// }
// .sp-status-badge {
//   display: inline-flex; align-items: center; gap: 6px;
//   padding: 4px 13px; border-radius: 20px;
//   background: #dcfce7; color: #166534;
//   border: 1px solid #86efac; font-size: 12px; font-weight: 700;
// }
.sp-status-dot { width: 7px; height: 7px; border-radius: 50%; background: #16a34a; }

/* BUTTONS */
.sp-action-row { display: flex; gap: 8px; flex-wrap: wrap; align-items: center; }
.sp-btn {
  display: flex; align-items: center; gap: 7px;
  padding: 9px 18px; border-radius: 9px; font-size: 13px; font-weight: 700;
  cursor: pointer; border: none; transition: all .15s;
  font-family: inherit; white-space: nowrap;
}
.sp-btn-outline { background: #fff; color: #0f4c75; border: 1px solid #bfdbfe; }
.sp-btn-outline:hover { background: #eff6ff; }
.sp-btn-teal  { background: #0d9488; color: #fff; }
.sp-btn-teal:hover  { background: #0f766e; }
.sp-btn-navy  { background: #0f4c75; color: #fff; }
.sp-btn-navy:hover  { background: #0c3d5e; }

/* SUMMARY STRIP */
.sp-summary-strip {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 14px; margin-bottom: 24px;
}
.sp-summary-box {
  background: #fff; border: 1px solid #e2e8f0;
  border-radius: 14px; padding: 16px 18px;
  position: relative; overflow: hidden;
  box-shadow: 0 2px 8px rgba(15,23,42,0.04);
}
.sp-summary-box::before {
  content: ''; position: absolute;
  top: 0; left: 0; right: 0; height: 3px;
  border-radius: 14px 14px 0 0;
}
.sp-summary-box.c-navy::before   { background: #0f4c75; }
.sp-summary-box.c-teal::before   { background: #0d9488; }
.sp-summary-box.c-amber::before  { background: #f59e0b; }
.sp-summary-box.c-green::before  { background: #16a34a; }
.sp-summary-box.c-purple::before { background: #7c3aed; }
.sp-summary-icon { font-size: 22px; margin-bottom: 8px; }
.sp-summary-val  { font-size: 14px; font-weight: 800; color: #0f172a; line-height: 1.3; }
.sp-summary-lbl  { font-size: 11px; color: #64748b; margin-top: 3px; font-weight: 500; }

/* SECTION CARD */
.sp-card {
  background: #fff; border: 1px solid #e2e8f0;
  border-radius: 16px; margin-bottom: 20px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(15,23,42,0.05);
}
.sp-card-hdr {
  display: flex; align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(to right, #f8fafc, #fff);
}
.sp-card-hdr-left { display: flex; align-items: center; gap: 12px; }
.sp-card-icon {
  width: 36px; height: 36px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  font-size: 17px; flex-shrink: 0;
}
.sp-card-title { font-size: 14px; font-weight: 700; color: #0f172a; }
.sp-card-sub   { font-size: 11px; color: #64748b; margin-top: 2px; }
.sp-card-count {
  font-size: 11px; font-weight: 700; color: #64748b;
  background: #f1f5f9; border: 1px solid #e2e8f0;
  padding: 2px 9px; border-radius: 20px;
}

/* FIELD GRID */
.sp-field-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
}
.sp-field {
  padding: 14px 18px;
  border-right: 1px solid #f1f5f9;
  border-bottom: 1px solid #f1f5f9;
  transition: background .12s;
}
.sp-field:hover { background: #fafbff; }
.sp-field.wide  { grid-column: span 2; }
.sp-field.wide3 { grid-column: span 3; }
.sp-field-label {
  font-size: 10px; font-weight: 700; color: #94a3b8;
  text-transform: uppercase; letter-spacing: .07em; margin-bottom: 5px;
}
.sp-field-val {
  font-size: 13px; font-weight: 600; color: #0f172a; line-height: 1.4;
}
.sp-field-val.empty { color: #cbd5e1; font-weight: 400; font-style: italic; }

/* CHIPS */
.sp-chip {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 3px 10px; border-radius: 20px;
  font-size: 11px; font-weight: 700;
}
.chip-blue   { background: #dbeafe; color: #1e40af; border: 1px solid #93c5fd; }
.chip-green  { background: #dcfce7; color: #166534; border: 1px solid #86efac; }
.chip-amber  { background: #fef9c3; color: #92400e; border: 1px solid #fde047; }
.chip-purple { background: #ede9fe; color: #5b21b6; border: 1px solid #c4b5fd; }
.chip-teal   { background: #ccfbf1; color: #0f766e; border: 1px solid #5eead4; }
.chip-red    { background: #fee2e2; color: #991b1b; border: 1px solid #fca5a5; }
.chip-navy   { background: #e0f2fe; color: #0369a1; border: 1px solid #7dd3fc; }

/* DOC LINKS */
.sp-doc-link {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 5px 12px; border-radius: 8px;
  background: #eff6ff; color: #1d4ed8;
  border: 1px solid #bfdbfe; font-size: 12px; font-weight: 600;
  cursor: pointer; text-decoration: none; transition: background .12s;
  font-family: inherit;
}
.sp-doc-link:hover { background: #dbeafe; }

/* PAYMENT GRID */
.sp-pay-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
}
.sp-pay-cell {
  padding: 16px 18px;
  border-right: 1px solid #f1f5f9;
  border-bottom: 1px solid #f1f5f9;
  transition: background .12s;
}
.sp-pay-cell:hover { background: #fafbff; }
.sp-pay-lbl { font-size: 10px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: .07em; margin-bottom: 5px; }
.sp-pay-val { font-size: 15px; font-weight: 800; color: #0f172a; }
.sp-pay-sub { font-size: 11px; color: #94a3b8; margin-top: 3px; }

/* FOOTER NOTE */
.sp-note {
  display: flex; align-items: flex-start; gap: 10px;
  background: #fefce8; border: 1px solid #fde047;
  border-radius: 12px; padding: 14px 18px;
  font-size: 12px; color: #854d0e; line-height: 1.7; margin-top: 8px;
}

/* CENTER */
.sp-center {
  display: flex; align-items: center; justify-content: center;
  min-height: 60vh; flex-direction: column; gap: 12px;
  font-family: 'Plus Jakarta Sans', sans-serif;
}

@media print {
  .sp-no-print { display: none !important; }
  .sp-root { background: #fff; padding: 10px; }
  .sp-card { box-shadow: none; break-inside: avoid; }
  body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
}
`;

/* ─── DEMO PAYMENT ──────────────────────────────────────────────────── */
// const DEMO_PAY = {
//   txn_id: "TXN20260523194512",
//   amount: "₹ 500.00",
//   mode: "Online (UPI)",
//   status: "Success",
//   bank_ref: "BNK9823710234",
//   paid_on: "23 May 2026, 07:45 PM",
// };

/* ─── HELPERS ───────────────────────────────────────────────────────── */
const fmt = (v) => {
  if (v === null || v === undefined || v === "") return null;
  if (typeof v === "boolean") return v ? "Yes" : "No";
  return String(v);
};

const Chip = ({ label, type = "blue" }) => (
  <span className={`sp-chip chip-${type}`}>{label}</span>
);

const Field = ({ label, value, wide, wide3 }) => {
  const cls = `sp-field${wide ? " wide" : ""}${wide3 ? " wide3" : ""}`;
  const isEmpty = value === null || value === undefined;
  return (
    <div className={cls}>
      <div className="sp-field-label">{label}</div>
      <div className={`sp-field-val${isEmpty ? " empty" : ""}`}>
        {isEmpty ? "—" : value}
      </div>
    </div>
  );
};

const Section = ({ icon, iconBg, title, sub, count, children }) => (
  <div className="sp-card">
    <div className="sp-card-hdr">
      <div className="sp-card-hdr-left">
        <div className="sp-card-icon" style={{ background: iconBg }}>{icon}</div>
        <div>
          <div className="sp-card-title">{title}</div>
          {sub && <div className="sp-card-sub">{sub}</div>}
        </div>
      </div>
      {count && <span className="sp-card-count">{count}</span>}
    </div>
    {children}
  </div>
);






/* ─── MAIN COMPONENT ────────────────────────────────────────────────── */
export default function StudentPreview({ studentRegNo }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const printRef = useRef();

  const handlePrint = useReactToPrint({
    contentRef: printRef,
  });
  function GetPreviewDetails() {
    setLoading(true);
    CommonAxiosGet(config.url.STU_URL + `getStudentPreview?studentRegNo=${studentRegNo}`)
      .then(res => {
        setData(res?.data?.scode === "01" ? res.data : null);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }

  useEffect(() => { GetPreviewDetails(); }, [studentRegNo]);

  if (loading) return (
    <><style>{CSS}</style>
      <div className="sp-root"><div className="sp-center">
        <div style={{ fontSize: 36 }}>⏳</div>
        <div style={{ fontSize: 14, color: "#64748b" }}>Loading preview…</div>
      </div></div></>
  );

  const p = data?.studentProfile?.[0] || {};
  const u = data?.studentUploads?.[0] || {};
  const paymentDtls = data?.paymentDetails?.[0] || {};

  return (
    <><style>{CSS}</style>
      <div className="sp-root">

        <div ref={printRef}>
          {/* PAGE HEADER */}
          <div className="sp-page-hdr">
            <div>
              <div className="sp-page-title"> Student Transfer Preview</div>

            </div>
            <div className="sp-action-row sp-no-print">

              <button className="sp-btn sp-btn-navy" onClick={handlePrint}>
                🖨️ Print
              </button>
            </div>
          </div>

          <Section icon="👨‍🎓" iconBg="#dbeafe" title="Personal Details" sub="Student's personal information"
          // count="9 fields"
          >
            <div className="sp-field-grid">
              <Field label="Student Name" value={fmt(p.student_name)} />
              <Field label="Registration No." value={<Chip label={fmt(p.student_reg_no) ?? "—"} type="blue" />} />
              <Field label="Father's Name" value={fmt(p.father_name)} />
              <Field label="Mother's Name" value={fmt(p.mother_name)} />
              <Field
                label="Date of Birth"
                value={p.dob ? new Date(p.dob).toLocaleDateString("en-GB") : "-"}
              />

              <Field label="Gender" value={<Chip label={fmt(p.gender) ?? "—"} type="purple" />} />

              <Field label="Mobile No." value={fmt(p.mobile_no)} />
              <Field label="Email Address" value={fmt(p.email)} />
              <Field label="Lateral Entry" value={p.lateral_entry ? <Chip label="Yes" type="green" /> : <Chip label="No" type="amber" />} />
              <Field label="Is this same syllabus" value={<Chip label={fmt(p.same_syllabus) ?? "—"} type="green" />} />


              <Field
                label="Current Syllabus Copy"
                value={
                  p.current_syllabus_copy ? (
                    <button
                      type="button"
                      className="btn btn-outline-success btn-sm"
                      onClick={() => viewImage(p.current_syllabus_copy)}
                    >
                      <FaFilePdf className="me-1" />
                      View PDF
                    </button>
                  ) : (
                    <span className="text-muted small">Not Uploaded</span>
                  )
                }
              />
            </div>
          </Section>

          {/* 2. ACADEMIC DETAILS */}
          <Section icon="📚" iconBg="#ede9fe" title="Current Academic Details  (From College)" sub="Course, year and semester information">
            <div className="sp-field-grid">
              <Field label="Year of Admission" value={fmt(p.year_of_admission)} />
              <Field label="Affiliated University" value={fmt(p.ub_name)} />
              <Field label="Present Studying College District" value={fmt(p.present_distname)} />
              <Field label="Present Studying Institution" value={fmt(p.prsent_collname)} />
              <Field label="College Code" value={fmt(p.present_coll_code)} />
              {/* <Field label="Institution Type" value={"ff"} /> */}
              <Field label="Course Name" value={<Chip label={fmt(p.course_name) ?? "—"} type="navy" />} />
              <Field label="Branch" value={fmt(p.branch_name)} />
              <Field label="Present Acad. Year" value={<Chip label={fmt(p.present_year) ?? "—"} type="amber" />} />
              <Field label="Present Semester" value={<Chip label={fmt(p.present_semester) ?? "—"} type="amber" />} />




            </div>
          </Section>


          {/* 4. TRANSFER DETAILS */}
          <Section icon="🔄" iconBg="#fef9c3" title="Transfer College Details  (To College)" sub="Destination college and transfer reason">
            <div className="sp-field-grid">
              <Field label="Transfer District" value={fmt(p.trans_distname)} />
              <Field label="Transfer College" value={fmt(p.trans_collname)} wide />
              <Field label="College Code" value={fmt(p.trans_coll_code)} />
              <Field label="Next Acad. Year" value={fmt(p.next_year)} />
              {console.log("kkkkk", p.next_year)}
              <Field label="Next Semester " value={fmt(p.next_semester)} />
              {/* <Field label="Is this same syllabus" value={<Chip label={fmt(p.transfer_same_syllabus) ?? "—"} type="green" />} />
              <Field
                label="Transfer Syllabus Copy"
                value={
                  p.transfer_syllabus_copy ? (
                    <button
                      type="button"
                      className="btn btn-outline-success btn-sm"
                      onClick={() => viewImage(p.transfer_syllabus_copy)}
                    >
                      <FaFilePdf className="me-1" />
                      View PDF
                    </button>
                  ) : (
                    <span className="text-muted small">Not Uploaded</span>
                  )
                }
              /> */}

              <Field label="Transfer Reason" value={<Chip label={fmt(p.transfer_reason) ?? "—"} type="amber" />} />
            </div>
          </Section>



          {/* 6. UPLOADED DOCUMENTS */}
          <Section icon="📎" iconBg="#fee2e2" title="Uploaded Documents" sub="Documents submitted along with application">
            <div className="sp-field-grid">

              <Field
                label="Medical Supporting Document"
                value={
                  u.supporting_document ? (
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => viewImage(u.supporting_document)}
                    >
                      <FaFilePdf className="me-1" />
                      View PDF
                    </button>
                  ) : (
                    <span className="text-muted small">Not Uploaded</span>
                  )
                }
              />

              <Field
                label="Undertaking Document"
                value={
                  u.undertaking_doc ? (
                    <button
                      type="button"
                      className="btn btn-outline-success btn-sm"
                      onClick={() => viewImage(u.undertaking_doc)}
                    >
                      <FaFilePdf className="me-1" />
                      View PDF
                    </button>
                  ) : (
                    <span className="text-muted small">Not Uploaded</span>
                  )
                }
              />


              <Field label="Agreed to Terms" value={u.agreetoterms ? <Chip label="✓ Agreed" type="green" /> : <Chip label="Not agreed" type="red" />} />

            </div>
          </Section>

          <Section
            icon="💳"
            iconBg="#ccfbf1"
            title="Payment Details"
            sub="Application fee payment information"
          >
            <div className="sp-pay-grid">
              <div className="sp-pay-cell">
                <div className="sp-pay-lbl">Amount Paid</div>
                <div className="sp-pay-val" style={{ color: "#15803d" }}>
                  ₹ {paymentDtls?.affl_fee}
                </div>
                <div className="sp-pay-sub">Application fee</div>
              </div>


              <div className="sp-pay-cell">
                <div className="sp-pay-lbl">Reference ID</div>
                <div className="sp-pay-val" style={{ fontSize: 13 }}>
                  {paymentDtls?.reference_id || "-"}
                </div>
                <div className="sp-pay-sub">Payment reference</div>
              </div>

              <div className="sp-pay-cell">
                <div className="sp-pay-lbl">Transaction ID</div>
                <div className="sp-pay-val" style={{ fontSize: 12 }}>
                  {paymentDtls?.transaction_id || "-"}
                </div>
                <div className="sp-pay-sub">Transaction reference</div>
              </div>

              <div className="sp-pay-cell">
                <div className="sp-pay-lbl">Academic Year</div>
                <div className="sp-pay-val" style={{ fontSize: 13 }}>
                  {paymentDtls?.ac_year || "-"}
                </div>
                <div className="sp-pay-sub">Academic year</div>
              </div>

              <div className="sp-pay-cell">
                <div className="sp-pay-lbl">Paid On</div>
                <div className="sp-pay-val" style={{ fontSize: 12 }}>
                  {paymentDtls?.entered_time
                    ? new Date(paymentDtls.entered_time).toLocaleString()
                    : "-"}
                </div>
                <div className="sp-pay-sub">Date & Time</div>
              </div>
            </div>
          </Section>

        </div>
      </div></>
  );
}